<div padding class="product-header ion-padding">
  <ion-grid>
    <!--ion-grid-starts-->
    <ion-row>

      <ion-col size="6" text-left class="text-left ion-text-left">
        <!--product info-->
        <div *ngIf="config.brandName" class="brand-name">{{config.brandName | multiLang}}</div>
        <h1 *ngIf="config.productName" class="smartlabel-h1 m-t-5 m-b-5">{{config.productName | multiLang}}</h1>
        <div *ngIf="config.netContent" class="product-info">{{netContent}}</div>
      </ion-col>
      <!--/product info-->


      <ion-col size="6" class="ion-text-center ion-justify-content-center">
        <!--product image-->
        <ng-template [ngIf]="config.productImageUrl">
          <div class="product-img-wrapper" [ngStyle]="{'background-image': 'url(' + config.productImageUrl.url + ')'}"
            (click)="gatemanService.routeHub(imageLink)">
          </div>
        </ng-template>

        <ng-template [ngIf]="config.upc">
          <div class="product-info m-t-5">GPC: {{config.upc}}</div>
        </ng-template>
        <ng-template [ngIf]="config.gtin">
          <div class="product-info m-t-5">{{config.gtin}}</div>
        </ng-template>


        <div class="variant-selector" *ngIf="productVariants.length > 1">
          <fa-icon class="info" [icon]="['fas', 'info-circle']" (click)="showPopover($event)">
          </fa-icon>
          <app-smartlabel-selector [config]="{
              class: 'smartlabel-selector m-b-15',
              optionClass: 'smartlabel-variant-selector-popover-option',
              interfaceOptions: { cssClass: 'smartlabel-variant-selector-popover'},
              options: productVariants,
              mode: 'ios',
              preSelectedIndex: pageService.variantDisplayIndex,
              type: 'product-variant-selector'}" (optionChange)="onOptionChange($event)">
          </app-smartlabel-selector>
        </div>
      </ion-col>
      <!--/product image-->


    </ion-row>
  </ion-grid>
  <!--/ion-grid-ends-->
</div>